<template>
  <fragment>
    <section
      class="hero section illustration-section-01"
      :class="[
        topOuterDivider && 'has-top-divider',
        bottomOuterDivider && 'has-bottom-divider'
      ]"
      image-fill
    >
      <div class="container">
        <div
          class="hero-inner section-inner"
          :class="[
            topDivider && 'has-top-divider',
            bottomDivider && 'has-bottom-divider'
          ]"
        >
          <div
            class="split-wrap"
            :class="[
              invertMobile && 'invert-mobile',
              invertDesktop && 'invert-desktop',
              alignTop && 'align-top'
            ]"
          >
            <div class="split-item">
              <div
                class="hero-content split-item-content center-content-mobile reveal-from-top"
              >
                <h1 class="mt-0 mb-16">{{ $t("employer.title") }}</h1>
                <p class="mt-0 mb-32">{{ $t("employer.subtitle") }}</p>
                <c-button-group>
                  <c-button
                    tag="a"
                    color="primary"
                    wide-mobile
                    @click="scrollDown()"
                    >{{ $t("employer.primaryAction") }}</c-button
                  >
                </c-button-group>
              </div>
              <div
                class="hero-figure split-item-image split-item-image-fill illustration-element-01 reveal-from-bottom"
              >
                <c-image
                  :src="require('@/assets/images/employer.jpg')"
                  alt=""
                  :width="528"
                  :height="396"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!--c-features-split invert-mobile image-fill /-->
    <c-features-tabs bottom-divider />
    <c-roadmap top-divider type="employer" />
    <c-clients
      top-divider
      :headingTitle="$t('employer.clients.title')"
      :headingText="$t('employer.clients.text')"
    />
    <!--c-testimonial top-divider type="employer" /-->
    <c-generic-section top-divider>
      <div class="container-xs">
        <c-section-header :data="faqHeading" class="center-content" />
        <c-accordion class="m-16">
          <c-accordion-item :title="$t('employer.faq.one.title')" active>{{
            $t("employer.faq.one.text")
          }}</c-accordion-item>
          <c-accordion-item :title="$t('employer.faq.two.title')">{{
            $t("employer.faq.two.text")
          }}</c-accordion-item>
          <c-accordion-item :title="$t('employer.faq.three.title')">{{
            $t("employer.faq.three.text")
          }}</c-accordion-item>
          <c-accordion-item :title="$t('employer.faq.four.title')">{{
            $t("employer.faq.four.text")
          }}</c-accordion-item>
        </c-accordion>
      </div>
    </c-generic-section>
    <section id="post-project" class="features-split has-bottom-divider">
      <div class="container">
        <div class="features-split-inner section-inner has-top-divider">
          <div class="split-wrap">
            <div class="split-item">
              <div
                class="split-item-image reveal-scale-up split-item-image-fill"
                data-reveal-container=".split-item"
                data-reveal-delay="200"
              >
                <c-section-header
                  :data="projectHeading"
                  class="center-content no-spacing"
                />
                <div
                  class="calendly-inline-widget"
                  data-url="https://calendly.com/michael-schoeffmann/campuskraft"
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </fragment>
</template>

<script>
// import layout
import CLayout from "@/layouts/LayoutDefault.vue";
import CImage from "@/components/elements/Image.vue";
import { SectionSplitProps } from "@/utils/SectionProps.js";
import CButtonGroup from "@/components/elements/ButtonGroup.vue";
import CButton from "@/components/elements/Button.vue";
import CGenericSection from "@/components/sections/GenericSection.vue";
import CSectionHeader from "@/components/sections/partials/SectionHeader.vue";
import CAccordion from "@/components/elements/Accordion.vue";
import CAccordionItem from "@/components/elements/AccordionItem.vue";
import CClients from "@/components/sections/Clients.vue";
import CRoadmap from "@/components/sections/Roadmap.vue";
import CFeaturesTabs from "@/components/sections/FeaturesTabs.vue";

export default {
  name: "Employer",
  components: {
    CImage,
    CButtonGroup,
    CButton,
    CClients,
    CGenericSection,
    CSectionHeader,
    CAccordion,
    CAccordionItem,
    CRoadmap,
    CFeaturesTabs
  },
  mixins: [SectionSplitProps],
  data() {
    return {
      demoModalActive: false
    };
  },
  methods: {
    submitApplication() {
      window.analytics.track("Company registration");
    },
    scrollDown() {
      let bottom = document.body.scrollHeight - 1500;
      window.scrollTo(0, bottom);
    }
  },
  computed: {
    faqHeading() {
      return {
        title: this.$i18n.t("employer.faq.title")
      };
    },
    projectHeading() {
      return {
        title: this.$i18n.t("employer.contact.headline"),
        paragraph: this.$i18n.t("employer.contact.subhead")
      };
    },
    yourName() {
      return this.$i18n.t("employer.contact.name");
    },
    yourEmail() {
      return this.$i18n.t("employer.contact.email");
    },
    yourPhone() {
      return this.$i18n.t("employer.contact.phone");
    },
    yourCompany() {
      return this.$i18n.t("employer.contact.company");
    }
  },
  created() {
    this.$emit("update:layout", CLayout);
  }
};
</script>

<style lang="scss" scoped>
@media (max-width: 640px) {
  .center-content-mobile {
    text-align: initial;
  }
  .cta-action {
    text-align: center;
  }
  .calendly-inline-widget {
    margin-top: 32px;
    min-width: 80% !important;
    height: 980px !important;
  }
}
@media (min-width: 821px) {
  .container .split-wrap .split-item .split-item-content {
    width: 548px;
  }
}
html {
  scroll-behavior: smooth;
}
.split-item-content {
  padding: 32px;
}
.split-item-image img {
  border-radius: 4px;
}
input[type="submit"] {
  vertical-align: middle !important;
  width: 100% !important;
  color: #fff !important;
  background-color: #ff6163 !important;
}
.form-checkbox {
  display: inline-block;
  input {
    padding-left: 0px;
  }
  p {
    padding-left: 8px;
  }
}
.calendly-inline-widget {
  min-width: 480px;
  height: 930px;
}
.no-spacing {
  padding-bottom: 0px !important;
}
</style>
